import { bulkEditPolicyTransaction } from "utils/api/policyTransactionApi";
import { EDIT_FIELD_BY_KEY } from "../product-details/editFields";
import { showToast } from "controls/global/stewart-toast";


 // Bulk Edit
export const handleBulkEditPolicyTransaction = async (
    selectedIds: string[],
    changes: { key: string, value: string }[],
    notes: string,
    newRemitSplitPcts?: { PolicyTransactionID: number, NewRemitSplitPct: number }[]
  ): Promise<boolean> => {

    // Agency Location is flattened in the modal into several already-API-shaped
    // keys, so they have no entry in EDIT_FIELD_BY_KEY and must pass through
    // untranslated instead of being filtered out.
    const AGENCY_LOCATION_FIELDS = new Set([
      "CompanyID",
      "CompanyName",
      "CompanyLegacyID",
      "LocationUniqueID",
      "LocationDisplayName",
      "LocationReportingID",
      "LocationAgencyCompanyID",
    ]);

    const editedRecordChanges = changes
      .filter(c => AGENCY_LOCATION_FIELDS.has(c.key) || Object.prototype.hasOwnProperty.call(EDIT_FIELD_BY_KEY, c.key))
      .map(c => ({
        key: AGENCY_LOCATION_FIELDS.has(c.key)
          ? c.key
          : EDIT_FIELD_BY_KEY[c.key].apiKey ?? EDIT_FIELD_BY_KEY[c.key].key,
        value: c.value,
      }));

    const keyValueFields = Object.fromEntries(
      editedRecordChanges.map(c => [c.key, c.value])
    )

    const bulkEditPayload = {
      PolicyTransactionIDList: selectedIds.join(", "),
      ...(notes ? { NoteText: notes } : {}),
      ...keyValueFields,
      ...(newRemitSplitPcts && newRemitSplitPcts.length > 0 ? { NewRemitSplitPcts: newRemitSplitPcts } : {}),
    }

    const response = await bulkEditPolicyTransaction(bulkEditPayload);
    if (response) {
      showToast({
        type: "success",
        message: `${selectedIds.length} record${selectedIds.length !== 1 ? "s" : ""} updated successfully.`,
      });
    }
    else {
      showToast({
        type: "error",
        message: `${selectedIds.length} record${selectedIds.length !== 1 ? "s" : ""} failed to update.`,
      });
    }

    return response;
  }